(function($){
	$(document).ready(function() {
		initLinks();
		initHeader();
		initSlider();
		initAccordion();
		initIconAccordion();
		initIconSwiper();
		initTrendingSwiper();
		initThumbnailSwiper();
		productImageControl();
		wrapSpecialChars();

		$(document).on('click','.bold-ro__radio-div',function(){
			if($('.bold-ro__one-time-div').hasClass('bold-ro__bold-active')) {
				$('.product__price').show();
			} else {
				$('.product__price').hide();
			}
		});

		$(document).on('click','.current-flavor',function(e){
			$('.flavor-selector').slideToggle();
            $('.current-flavor').toggleClass("active");
		});


		function initLinks() {
			$('a[href]:not([href^="#"])').each(function(){
				var _this = $(this);
				var _thisHref = _this.attr('href');

				if((_thisHref.startsWith('/') ||
					_thisHref.includes(siteUrl.replace('www.', '').replace('http://', '').replace('https://', '')))
					&& _this.attr('target') != '_blank'
					&& !_thisHref.includes('mailto:')){
					_this.attr('data-location','internal')
				} else {
					_this.attr('data-location','external').attr('target', '_blank');
				}
			});
		}

		// Bookmark on same page
		$('a[href*="#"]:not([href="#"]):not(".no-scroll")').click(function(e) {
	     	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {

	      		var target = $(this.hash);

	      		headerHeight = 120;

	      		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

		      	if (target.length) {
			        $('html,body').stop().animate({
			          scrollTop: target.offset().top - 250 //offsets for fixed header
			        }, 'linear');
			    }
	    	}
	  	});

		// Coming to bookmark from different page
		var hash= window.location.hash;
		if ( hash == '' || hash == '#' || hash == undefined ) return false;

	    var target = $(hash);
      	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

      	if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 250 //offsets for fixed header
	        }, 'linear');
	    }

		// the following function is for add / removing opacity and adjusting the size on the navigation on scroll
		function initHeader(){
			// set initial nav opacity
			var scrollPosition = $(window).scrollTop();
			var startScrollTop = null;
			var lastScrollTop = 0;
			var scrolledPixels = 0;
			var lastScrollDirection = "down";
			
			if(scrollPosition > 10){
				$(".nav-overlay").addClass('visible');
			}

			// Remove opacity of nav on scro(ll
			$(window).scroll(function() {
				scrollPosition = $(window).scrollTop();

				// scroll logic
				var scrollTop = $(this).scrollTop();
				if (startScrollTop === null) {
					startScrollTop = scrollTop;
				}
				scrolledPixels = Math.abs(scrollTop - startScrollTop);
				var scrollDirection = scrollTop > lastScrollTop ? "down" : "up";
				if (scrollDirection === "down" && scrolledPixels > 100) {
					$(".site-header").addClass("small-scroll");
				} else if(scrollDirection === "up" && scrolledPixels > 50) {
					$(".site-header").removeClass("small-scroll");
				}
				lastScrollTop = scrollTop;
				if (scrollDirection !== lastScrollDirection) {
					startScrollTop = scrollTop;
				}
				lastScrollDirection = scrollDirection;
				// end of scroll logic

				if(scrollPosition > 10){
					$(".nav-overlay").addClass('visible');
				}else{
					$(".nav-overlay").removeClass('visible');
				}
			})
		}

		// homepage product slider
		function initSlider(){
			var swiper = new Swiper(".swiper", {
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				grabCursor: true,
				// centeredSlides: true,
				// loop: true,
				// slidesPerView: 4,
				// autoHeight: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				breakpoints: {
					768: {
						centeredSlides: false,
					},
				},
			});
		}

		// icon accordion
		function initIconAccordion() {
			const accordionItems = document.querySelectorAll('.icon-accordion-outer .accordion-item');
			accordionItems.forEach(item => {
				item.addEventListener('click', () => {
					const activeItem = document.querySelector('.icon-accordion-outer .accordion-item.open');
					if (activeItem && activeItem !== item) {
						activeItem.classList.remove('open');
					}
					item.classList.toggle('open');
				});
			});
		}

		// faq accordion
		function initAccordion() {
			const accordionItems = document.querySelectorAll('.section-new-accordion li');
			accordionItems.forEach(item => {
				item.querySelector('.question').addEventListener('click', () => {
					const activeItem = document.querySelector('.section-new-accordion li.open');
					if (activeItem && activeItem !== item) {
						activeItem.classList.remove('open');
					}
					item.classList.toggle('open');
				});
			});
		}

		// icon swiper on product page
		function initIconSwiper(){
			var swiper = new Swiper(".icon-swiper", {
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				grabCursor: true,
				spaceBetween: 20
			});
		}

		// product page product slider
		function initTrendingSwiper(){
			setTimeout(() => {
				var swiper = new Swiper(".trending-swiper", {
					slidesPerView: 'auto',
					slidesPerGroup: 1,
					grabCursor: true,
					// centeredSlides: true,
					// loop: true,
					// slidesPerView: 4,
					// autoHeight: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					breakpoints: {
						768: {
							centeredSlides: false,
						},
					},
				});
			}, 2000)
		}

		function initThumbnailSwiper(){
			var swiper = new Swiper(".thumbnail-swiper", {
				slidesPerView: 1,
				slidesPerGroup: 1,
				grabCursor: true,
				spaceBetween: 20,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			});
		}
		
		// product images on desktop
		function productImageControl(){
			const smallImages = document.querySelectorAll('.product-single__thumbnail-image');
			smallImages.forEach(image => {
				image.addEventListener('click', () => {
					var mainImage = document.querySelector('.feature-row__image-main');
					mainImage.src = image.src;
					mainImage.alt = image.alt;
				})
			})
		}

		// wrap all R and TM special characters in <sup> tags
		function wrapSpecialChars(){
			var elements = document.querySelectorAll('*:not(script):not(noscript):not(style):not(textarea):not(input):not(select):not(iframe):not(canvas):not(svg):not(audio):not(video)');
			for (var i = 0; i < elements.length; i++) {
				var element = elements[i];
				for (var j = 0; j < element.childNodes.length; j++) {
					var node = element.childNodes[j];
					if (node.nodeType === Node.TEXT_NODE) {
						var newText = node.textContent.replace(/™/g, '<sup>™</sup>').replace(/®/g, '<sup>®</sup>');
						if (newText !== node.textContent) {
							var newNode = document.createElement('span');
							newNode.innerHTML = newText;
							element.replaceChild(newNode, node);
						}
					}
				}
			}

		}

	});
	
})(jQuery);

function IndexCollectionSlider() {
	let slider = document.querySelector('.collection-slider__wrapper')
	if (slider){
		function loadSlider() {
			if (slider.classList.contains('slick-initialized')) {
				$('.collection-slider__wrapper').slick('unslick')
			}
			if (window.innerWidth >= 1024) {
				$('.collection-slider__wrapper').slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 4,
					arrows: false,
					dots: true
				});
			} else if (window.innerWidth < 1024 && window.innerWidth > 600) {
				$('.collection-slider__wrapper').slick({
					infinite: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows: false,
					dots: true
				});
			} else {
				$('.collection-slider__wrapper').slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					centerMode: true,
					centerPadding: '50px',
					dots: true
				});
			}
		}
		loadSlider()
		$(window).on('resize orientationchange', function () {
			loadSlider()
		});
	}
}

document.addEventListener('DOMContentLoaded', IndexCollectionSlider);
document.addEventListener('shopify:section:reorder', IndexCollectionSlider);
document.addEventListener('shopify:section:load', IndexCollectionSlider);


function IndexHeroSlider() {
	let slider = document.querySelectorAll('.index-hero-slider__wrapper')
	if (slider.length){
		slider.forEach(slide => {
			let autoplay = $(slide).attr('data-autoplay')
			let autoplay_speed = $(slide).attr('data-autoplay-speed')
			$(slide).slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				autoplay: autoplay,
				autoplaySpeed: autoplay_speed,
				dots: false
			});
		})
	}
}

document.addEventListener('DOMContentLoaded', IndexHeroSlider);
document.addEventListener('shopify:section:reorder', IndexHeroSlider);
document.addEventListener('shopify:section:load', IndexHeroSlider);

window.addEventListener("scroll", scrollFunc);
document.addEventListener("DOMContentLoaded", scrollFunc);
function scrollFunc() {
	var elements = [
		...document.querySelectorAll(".fade-in:not(.active)"), 
		...document.querySelectorAll(".fade-in-left:not(.active)"), 
		...document.querySelectorAll(".fade-in-right:not(.active)"),
		...document.querySelectorAll(".fade-in-up:not(.active)"),
		...document.querySelectorAll(".fade-in-down:not(.active)"),
		...document.querySelectorAll(".waves-container:not(.active)"),
		...document.querySelectorAll(".animated-accordion:not(.active)"),
		...document.querySelectorAll(".animated-grid:not(.active)"),
		...document.querySelectorAll(".partner-circle:not(.active)"),
		...document.querySelectorAll(".animate:not(.active)"),
	];
	for (var i = 0; i < elements.length; i++) {
		var windowHeight = window.innerHeight;
		var elementTop = elements[i].getBoundingClientRect().top;
		var elementVisible = 200;
		if (elementTop < windowHeight - elementVisible || elements[i].classList.contains("initiate")) {
			elements[i].classList.add("active");
		}
	}
}
  